import React, { useEffect } from 'react';
import useDefaultPortalConfigurationService, {
  ShortDefaultPortalConfiguration
} from './defaultPortalConfigurationService';
import { ItemsList, TextLink, useFormContextRequired } from 'ui-builder';
import { InformationMessage } from 'features/nekst-widgets';
import { ProjectType } from 'nekst-api';
import { FormType, useFormMapper } from './defaultPortalConfigurationFormMapper';

export function CopyConfigurationWidget(
  props: {
    setupAreaId?: number,
    projectType: ProjectType,
  }
) {
  const portalConfigurationService = useDefaultPortalConfigurationService();

  const formContext = useFormContextRequired<FormType>();

  const formData = formContext.data;

  const hasData = formData?.title;

  const [existingConfigurations, setExistingConfigurations] = React.useState<ShortDefaultPortalConfiguration[]>();

  const formMapper = useFormMapper();

  async function loadConfigurationForSetupArea(setupAreaId: number) {
    const setupAreaConfiguration = await portalConfigurationService.getPortalConfiguration(
      props.projectType,
      setupAreaId
    );

    const newFormData = formMapper.toFormView(setupAreaConfiguration);
    formContext.setFormData({
      ...newFormData,
      detailFieldsIds: [],
    });
  }

  useEffect(() => {
    async function loadConfigurations() {
      const configurations = await portalConfigurationService.getAllConfigurations(props.projectType);
      setExistingConfigurations(configurations);
    }

    if (!hasData) {
      loadConfigurations();
    }
  }, [props.projectType, props.setupAreaId]);


  if (existingConfigurations && existingConfigurations.length > 0) {
    return (
      <InformationMessage>
        Client Portal configuration is not setup for this market. You can copy configuration from other markets:
        <ItemsList
          items={existingConfigurations.map((config) => {
            return (
              <TextLink
                onClick={async () => {
                  await loadConfigurationForSetupArea(config.setupArea.setupAreaId)
                }}
              >{config.setupArea.name}</TextLink>
            )
          })}
        />
      </InformationMessage>
    )
  } else {
    return null;
  }
}


